import { createContext } from '@10d/tend-ui-factories';

const [ColumnsSettingsPresetsProvider, useColumnsSettingsPresetsProvider] = createContext('ColumnsSettingsPresetsProvider');

export { ColumnsSettingsPresetsProvider, useColumnsSettingsPresetsProvider };
